import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "layout__wrapper" }

import { onBeforeMount, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { useRouter } from 'vue-router'
import { backend } from '@/services/backend'
import { CustomListWithDocs, Doc } from '@/models/interfaces'

import Layout from '@/app/components/Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyLibrary',
  setup(__props) {

const docs = ref<Doc[] | null>(null)
const lists = ref<CustomListWithDocs[] | null>(null)
const wait = useWait()
const router = useRouter()

onBeforeMount(() => {
  loadDocuments()
})

const loadDocuments = async (): Promise<void> => {
  try {
    wait.start('Loading Docs')
    wait.end('Error Loading Docs')

    docs.value = await backend.getUserDocs()
    lists.value = await backend.getCustomLists()
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      router.push({ name: 'not_found' })
    } else {
      wait.start('Error Loading Docs')
      if (Sentry) {
        Sentry.captureException(error)
      }
    }
  } finally {
    wait.end('Loading Docs')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoadingError = _resolveComponent("LoadingError")!

  return (_unref(wait).is('Loading Docs'))
    ? (_openBlock(), _createBlock(Layout, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_loading_spinner)
          ])
        ]),
        _: 1
      }))
    : (docs.value && lists.value)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 1,
          docs: docs.value,
          lists: lists.value
        }, null, 8, ["docs", "lists"]))
      : ((!docs.value || !lists.value) && _unref(wait).is('Error Loading Docs'))
        ? (_openBlock(), _createBlock(Layout, { key: 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_LoadingError)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
}
}

})